/* ============
 * User Layout
 * ============
 *
 * This is the layout for the authenticated user.
 */

import { mapGetters } from 'vuex';
import authService from './../../services/auth';
import accountService from './../../services/account';

export default {
  data() {
    return {
      sideMenuActive: false,
      expanded: false,
      index: 0,
      activeItemSubMenu: null,
      alertWarning: '',
      hasUnpaidInvoice: false,
      unpaidInvoicePollId: null,
    };
  },
  computed: {
    ...mapGetters([
      'innerSidebarState',
      'innerSidebar',
      'stockMutationsHandedOff',
      'stockDecommissioned',
      'inventoryAppUrl',
    ]),
    bridgeHandoffMessage() {
      if (this.stockDecommissioned) {
        return this.$t('static.bridgeHandoff.decommissioned');
      }
      if (this.stockMutationsHandedOff) {
        return this.$t('static.bridgeHandoff.handedOff');
      }
      return '';
    },
  },
  methods: {
    toggleInnerSideMenuAndRoute(event, route) {
      const scopeIndexes = [2, 5, 7, 8, 9];
      this.index = Number(event.index);
      if (this.$route.name === route) {
        if (scopeIndexes.includes(Number(event.index))) return;

        this.expanded = !this.expanded;
        return;
      }

      if (!scopeIndexes.includes(Number(event.index))) {
        this.expanded = true;
      } else {
        this.expanded = false;
      }

      this.$router.push({
        name: route,
      });
    },

    /**
     * Closes inner side menu.
     */
    closeInnerSideMenu() {
      this.expanded = false;
    },

    /**
     * This method will toggle the sidebar.
     */
    toggleMenu() {
      this.sideMenuActive = !this.sideMenuActive;
    },

    /**
     * This method will logout the user.
     */
    logout() {
      authService.logout();
    },

    /**
     * Re-check whether the current organization has an overdue invoice and
     * show/hide the warning banner accordingly. Safe to call repeatedly.
     */
    checkUnpaidInvoice() {
      accountService.unpaidInvoice().then((data) => {
        this.hasUnpaidInvoice = (data !== 'noShow' && data && data.hasUnpaidInvoice === true);
      }).catch((errors) => {
        console.log(errors);
      });
    },

    /**
     * Re-check when the user returns to the tab — covers the common case of
     * a user who keeps the app open for hours without ever reloading.
     */
    handleVisibilityChange() {
      if (!document.hidden) {
        this.checkUnpaidInvoice();
      }
    },
  },
  watch: {
    // Re-check on every in-app navigation so the banner updates as the user
    // moves around, not only on a full page load.
    $route() {
      this.checkUnpaidInvoice();
    },
  },
  mounted() {
    Promise.all([
      accountService.subscription()
    ]).then((data) => {
      if (data[0] !== 'noShow') {
        const transRoot = 'static.accountAlert';
        const endedOrEnding = (data[0]['dateDiff'] > 0 ) ? this.$t(transRoot+'.msgPart2Ending') : this.$t(transRoot+'.msgPart2Ended');
        const dayWithS = (data[0]['dateDiff'] === 1 ) ? this.$t(transRoot+'.partial.day') : this.$t(transRoot+'.partial.days');
        const days = (data[0]['dateDiff'] > 0 ) ? this.$t(transRoot+'.partial.willEndIn')+' '+data[0]['dateDiff']+' '+dayWithS+', ' : '';
        this.alertWarning = this.$t(transRoot+'.greetings')+', '+days+' '+endedOrEnding;
      }
    }).catch((errors) => {
      console.log(errors);
    });

    this.checkUnpaidInvoice();
    // Poll periodically so a flag flipped in Nova reaches an open session
    // within ~a minute without the user reloading.
    this.unpaidInvoicePollId = setInterval(this.checkUnpaidInvoice, 60000);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    if (this.unpaidInvoicePollId) {
      clearInterval(this.unpaidInvoicePollId);
      this.unpaidInvoicePollId = null;
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  components: {
    VSidebar: require('./../../components/sidebar/sidebar.vue'),
    VHeader: require('./../../components/header/header.vue'),
    VDialog: require('./../../components/modal/modal.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/layouts/user/user.js